import Box from '@mui/material/Box';
import Slider, { type SliderProps } from '@mui/material/Slider';
import { forwardRef } from 'react';
import getStyleQuery from '../../../utils/tools/getStyleQuery';

const CustomSlider = forwardRef<HTMLInputElement, SliderProps & { hasIcon?: boolean }>(function CustomSlider(props: SliderProps & { hasIcon?: boolean }, ref) {
    return (
        <Box ref={ref} sx={{ [getStyleQuery()]: { ml: props?.hasIcon ? '14px' : '20px', my: '12.5px', width: 1, zIndex: 1 } }}>
            <Slider
                aria-label={props['aria-label'] ?? 'Slider'}
                data-testid={props?.['data-testid']}
                disabled={props?.disabled}
                getAriaValueText={props?.getAriaValueText}
                valueLabelDisplay={props?.valueLabelDisplay ?? 'auto'}
                valueLabelFormat={props?.valueLabelFormat}
                onChange={props?.onChange}
                onChangeCommitted={props?.onChangeCommitted}
                marks={props?.marks}
                max={props?.max}
                min={props?.min}
                step={props?.step}
                slots={props?.slots}
                sx={{ [getStyleQuery()]: { m: 0 } }}
                value={props?.value}
            />
        </Box>
    );
});

export default CustomSlider;
